import { useEffect, useState } from "react";
import { getGlobalLeaderboard } from "../../features/competition/competitionSlice";
import { useSelector, useDispatch } from "react-redux";

function Leaderboard() {
  const { globalLeaderboard, showSpinner } = useSelector((state) => state.competitions);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGlobalLeaderboard());
  }, [dispatch]);

  return (
    <div className="space-y-4 max-h-96 overflow-y-auto pr-2 font-mono">
      {showSpinner ? (
        <div className="flex justify-center items-center h-32">
          <div className="w-8 h-8 border-4 border-lime-400 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : globalLeaderboard?.length > 0 ? (
        <div>
          {/* Leaderboard Header */}
          <div className="grid grid-cols-12 gap-2 mb-2 text-xs font-bold px-3 py-2 border-b border-lime-500/30 text-lime-400 uppercase tracking-wider">
            <div className="col-span-1">Rank</div>
            <div className="col-span-5">Display Name</div>
            <div className="col-span-3 text-right">Total Points</div>
            <div className="col-span-3 text-right">Competition Count</div>
          </div>

          {/* Contestants List */}
          <div className="space-y-2">
            {globalLeaderboard.map((contestant) => (
              <div 
                key={contestant._id}
                className="grid grid-cols-12 gap-2 bg-zinc-800/50 hover:bg-zinc-800 transition-colors rounded-lg px-3 py-4 items-center cursor-pointer hover:shadow-[0_0_10px_rgba(163,230,53,0.5)]"
              >
                <div className="col-span-1 text-2xl font-bold">
                  {contestant.rank <= 3 ? (
                    <span className={`${
                      contestant.rank === 1 ? 'text-yellow-400' : 
                      contestant.rank === 2 ? 'text-zinc-300' : 
                      'text-amber-700'
                    }`}>
                      {contestant.rank}
                    </span>
                  ) : (
                    <span className="text-zinc-500">{contestant.rank}</span>
                  )}
                </div>
                <div className="col-span-5">
                  <h3 className="text-white font-bold">
                    {contestant.displayName}
                  </h3>
                </div>
                <div className="col-span-3 text-right font-bold text-lime-400">
                  {contestant.totalScore || 0} pts
                </div>
                <div className="col-span-3 text-right text-zinc-400">
                  {contestant.totalCompleted || 0} completed
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="bg-zinc-800/20 rounded-lg p-8 text-center">
          <p className="text-zinc-400">No leaderboard data available.</p>
          <p className="text-zinc-500 text-sm mt-2">Participate in competitions to appear here!</p>
        </div>
      )}
    </div>
  );
}

export default Leaderboard;